"use strict";

module.exports = /*@ngInject*/function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      divider: '=divider',
      disabled: '=disabled',
      icon: '@icon',
      label: '@label'
    },
    template: '<button class="menu-item"><span class="{{icon}}"></span>{{label}}</button>',
    // eslint-disable-next-line object-shorthand
    link: function link(scope, element, attr) {
      element.addClass(scope.disabled ? 'disabled' : '');
      if (attr.divider !== undefined) {
        element.wrap("<li class='divider-margin'></li>");
        element.addClass('divider disabled');
        element[0].setAttribute('tabindex', -1);
      } else {
        element.wrap('<li></li>');
        element[0].setAttribute('tabindex', 0);
      }
    }
  };
};